var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, flow } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { WP_URL } from '../../env';
import { useControllers } from '../../hooks/controller.hooks';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import joinClassName from '../../utils/className.utils';
import { debounce } from '../../utils/debouncer.utils';
import { reportError } from '../../utils/errors.utils';
import { useStore } from '../../utils/mobx.utils';
import AppPage from '../AppPage/AppPage';
import AppPageContent from '../AppPageContent/AppPageContent';
import AppPageHeader from '../AppPageHeader/AppPageHeader';
import BaseButton from '../BaseButton/BaseButton';
import BaseIcon from '../BaseIcon/BaseIcon';
import BaseSpacer from '../BaseSpacer/BaseSpacer';
import LoadingBlocker from '../LoadingBlocker/LoadingBlocker';
import OverlayCloseButton from '../OverlayCloseButton/OverlayCloseButton';
import SearchResultGrid from '../Search/SearchResultGrid/SearchResultGrid';
import SearchBar from '../SearchBar/SearchBar';
import UIBlock from '../UIBlock/UIBlock';
import './NavSearch.scss';
export var filters;
(function (filters) {
    filters["all"] = "all";
    filters["services"] = "services";
    filters["blogPosts"] = "blogPosts";
})(filters || (filters = {}));
var NavSearch = function (props) {
    var _a = useControllers(), API = _a.API, UI = _a.UI;
    var MAX_PER_PAGE = 100;
    var s = useStore(function () { return ({
        form: {
            userInput: '',
            filters: { services: true, blogPosts: true },
        },
        posts: [],
        allServices: [],
        allTags: [],
        services: [],
        pages: [],
        tags: [],
        isLoading: false,
        onMountDataFetcher: action(function () { return __awaiter(void 0, void 0, void 0, function () {
            var allServicesAPICall, allTagsAPICall, responses, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        allServicesAPICall = API.get(WP_URL + "/wp-json/wp/v2/services?context=embed&per_page=" + MAX_PER_PAGE + "&page=1&_embed");
                        allTagsAPICall = API.get(WP_URL + "/wp-json/wp/v2/tags?context=embed&per_page=" + MAX_PER_PAGE + "&page=1&_embed");
                        s.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all([allServicesAPICall, allTagsAPICall])];
                    case 2:
                        responses = _a.sent();
                        s.allServices = responses[0].data;
                        s.allTags = responses[1].data;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        reportError(e_1);
                        UI.DIALOG.error({
                            heading: "Failed to get initial services and tags...",
                            error: e_1,
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        s.isLoading = false;
                        return [2 /*return*/];
                }
            });
        }); }),
        handleSearchServices: action(function (searchQuery) {
            // if searchQuery in content, title, tags.
            var filteredServices = s.allServices.filter(function (service) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                var matchesContent = (_c = (_b = (_a = service.content) === null || _a === void 0 ? void 0 : _a.rendered) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchQuery)) !== null && _c !== void 0 ? _c : false;
                var matchesTitle = (_f = (_e = (_d = service.title) === null || _d === void 0 ? void 0 : _d.rendered) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(searchQuery)) !== null && _f !== void 0 ? _f : false;
                var matchesTags = (_k = (_j = (_h = (_g = service._embedded) === null || _g === void 0 ? void 0 : _g['wp:term']) === null || _h === void 0 ? void 0 : _h[1]) === null || _j === void 0 ? void 0 : _j.some(function (tag) { return tag.name.toLowerCase().includes(searchQuery); })) !== null && _k !== void 0 ? _k : false;
                return matchesContent || matchesTitle || matchesTags;
            });
            s.services = filteredServices;
        }),
        search: debounce(action(flow(function (userInput) {
            var pageAPICall, postCall, tagAPICall, responses, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userInput)
                            return [2 /*return*/];
                        s.isLoading = true;
                        s.form.userInput = userInput;
                        s.handleSearchServices(userInput);
                        pageAPICall = API.get(WP_URL + "/wp-json/wp/v2/pages?search=" + userInput + "&context=embed&per_page=10&page=1&_embed");
                        postCall = API.get(WP_URL + "/wp-json/wp/v2/posts?search=" + userInput + "&context=embed&per_page=50&page=1&_embed");
                        tagAPICall = API.get(WP_URL + "/wp-json/wp/v2/tags?search=" + userInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all([pageAPICall, postCall, tagAPICall])];
                    case 2:
                        responses = _a.sent();
                        s.pages = responses[0].data;
                        s.posts = responses[1].data;
                        s.tags = responses[2].data;
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        reportError(e_2);
                        UI.DIALOG.error({
                            heading: "Failed to search for " + userInput + "...",
                            error: e_2,
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        s.isLoading = false;
                        return [2 /*return*/];
                }
            });
        })), 500),
        get hasResults() {
            var _a;
            return (_a = !(s.posts.length === 0 && s.services.length === 0 && s.pages.length === 0 && s.tags.length === 0)) !== null && _a !== void 0 ? _a : true;
        },
        showSearchOverlay: function () {
            var _a;
            (_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.classList.add("noscroll");
            UI.OVERLAY.present({
                name: "OverlaySearch",
                component: React.createElement(Observer, { children: function () { return (React.createElement(AppPage, { className: "OverlaySearch" },
                        React.createElement(AppPageHeader, { title: React.createElement(React.Fragment, null,
                                React.createElement(BaseIcon, { icon: "search", variant: "filled" }),
                                "Search turn2me"), endSlot: React.createElement(OverlayCloseButton, null) }),
                        React.createElement(AppPageContent, { className: "OverlayScroller" },
                            React.createElement(UIBlock, { padded: true, spaceChildren: true },
                                React.createElement(SearchBar, { form: s.form, field: "userInput", placeholder: "Look for turn2me services, or our Information Centre articles\u2026", autoFocus: true, onChange: s.search, inputIncludeSpace: true }),
                                s.isLoading && React.createElement(LoadingBlocker, null),
                                !s.isLoading && s.form.userInput ?
                                    s.hasResults && React.createElement(SearchResultGrid, { results: s }) :
                                    React.createElement("div", { className: "NoSearchQueryWrapper" },
                                        React.createElement("div", { className: "NoSearchQuery" },
                                            React.createElement("h3", { className: "BeforeTitle" }, "turn2me"),
                                            React.createElement("h3", { className: "Title" }, "Search"),
                                            React.createElement("p", null, "Use our smart search bar above to search our archive of Information Centre articles, our Services, or other pages with useful information for you."))),
                                !s.isLoading && s.form.userInput && !s.hasResults && React.createElement(React.Fragment, null,
                                    React.createElement(BaseSpacer, null),
                                    React.createElement("div", { className: "SearchNoResults" }, "Nothing relevant found! Try using a different search term...")))))); } }),
                width: '90vw',
                duplicateStrategy: 'abort',
                onBeforeClose: function () { return new Promise(function (resolve, reject) {
                    var _a;
                    (_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.classList.remove("noscroll");
                    resolve(true);
                }); },
            });
        }
    }); });
    useOnMount(function () {
        s.onMountDataFetcher();
        // s.search(s.form.userInput)
        // s.showSearchOverlay()
    });
    return (React.createElement(Observer, { children: function () { return (React.createElement(BaseButton, { className: joinClassName("NavSearch"), title: "Find turn2me blog posts and services", name: "nav-search", appearance: "icon", icon: "search", iconVariant: "filled", onClick: s.showSearchOverlay })); } }));
};
export default NavSearch;
